<template>
    <div v-if="claims.upcomingEvent.read" class="mb-3" :class="sizeClassObject">
        <UpcomingEvents ref="upcomingEventsGrid"
                        @sizeToggle="sizeToggle"
                        @rejected="upcomingEventsRejected"
                        @confirmed="upcomingEventsConfirmed"
                        :upcomingEventsExpanded="expanded">
        </UpcomingEvents>
    </div>
</template>

<script src="https://kendo.cdn.telerik.com/2019.2.619/js/pako_deflate.min.js"></script>

<script>
    import UpcomingEvents from '@/components/dynamic/events/UpcomingEvents';
    import { DynamicLayoutPageSize } from '@/models/enums';
    import { mapGetters } from 'vuex';

    export default {
        props: {
            size: Number
        },
        data() {
            return {
                expanded: this.size == 12
            }
        },
        components: {
            UpcomingEvents
        },
        computed: {
            sizeClassObject() {
                return this.$helpers.sizeClassObject(this.expanded ? DynamicLayoutPageSize.Max : Math.min(this.size, 6));
            },
            ...mapGetters(['claims'])
        },
        methods: {
            sizeToggle() {
                this.expanded = !this.expanded;
            },
            upcomingEventsRejected(model) {
                this.reloadPendingConfirmationsListGrid()
                this.reloadConfrimationsListGrid()
            },
            upcomingEventsConfirmed(model) {
                this.reloadPendingConfirmationsListGrid()
                this.reloadConfrimationsListGrid()
            },
            reloadPendingConfirmationsListGrid() {
                const gr = this.$refs.pendingConfirmationGrid
                if (gr) {
                    gr.reload()
                }
            },
            reloadConfrimationsListGrid() {
                const gr = this.$refs.confirmationsListGrid
                if (gr) {
                    gr.reload()
                }
            }
        }
    }
</script>
